import { render, staticRenderFns } from "./A2HSInstallPrompt.vue?vue&type=template&id=45d239c4&scoped=true"
import script from "./A2HSInstallPrompt.vue?vue&type=script&lang=js"
export * from "./A2HSInstallPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d239c4",
  null
  
)

export default component.exports